import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Lines, SectionTag } from "../site/Motion";
import { useApp } from "../../context/AppContext";
import { IMG } from "../../lib/images";

export function FinalCta() {
  const { selectedColour, colourSlug } = useApp();

  return (
    <section id="finale" data-testid="final-preorder-section" className="theme-dark relative overflow-hidden border-t border-white/10">
      <div className="absolute inset-0">
        <img src={IMG.hero} alt="SWAPA pronta alla consegna" className="h-full w-full object-cover opacity-30" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink" aria-hidden="true" />
      </div>
      <div className="relative mx-auto max-w-[1600px] px-5 py-28 text-center sm:px-10 sm:py-44">
        <SectionTag index="15" label="La tua SWAPA" />
        <h2 className="mt-10 font-display font-black uppercase leading-[0.9] tracking-tighter">
          <Lines lines={["Your SWAPA"]} className="text-[14vw] text-white sm:text-8xl lg:text-9xl" />
          <Lines lines={["is ready."]} delay={0.15} className="text-[14vw] text-white sm:text-8xl lg:text-9xl" />
        </h2>

        <Reveal delay={0.3}>
          {selectedColour && (
            <p data-testid="final-selected-colour" className="mt-8 inline-flex items-center gap-3 border border-white/15 bg-black/50 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-300 backdrop-blur-sm">
              <span className="h-4 w-4 rounded-full border border-white/25" style={{ backgroundColor: selectedColour.hex }} aria-hidden="true" />
              Colore scelto: {selectedColour.name}
            </p>
          )}
          <p className="mt-8 font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">
            Swapa™ — €13.990 <span className="text-sm font-medium normal-case tracking-normal text-zinc-500">IVA inclusa</span>
          </p>
          <p className="mt-2 font-mono text-xs uppercase tracking-[0.25em] text-swapa-yellow">La prenoti oggi con €200</p>
        </Reveal>

        <Reveal delay={0.4}>
          <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              to={`/preordina${colourSlug ? `?colore=${colourSlug}` : ""}`}
              data-testid="final-preorder-cta"
              className="group inline-flex items-center gap-3 bg-swapa-yellow px-10 py-5 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-black transition-transform duration-300 hover:-translate-y-0.5"
            >
              Pre-ordina ora — €200
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <Link
              to="/test-drive"
              data-testid="final-testdrive-cta"
              className="inline-flex items-center gap-3 border border-white/30 px-10 py-5 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:border-swapa-yellow hover:text-swapa-yellow"
            >
              Prenota un test drive
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
